import script from "./FilterRange.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterRange.vue?vue&type=script&lang=ts&setup=true"

import "./FilterRange.vue?vue&type=style&index=0&id=534c4c1e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-534c4c1e"]])

export default __exports__